module.exports = __webpack_public_path__ + "media/images/img_top_guide02_sp-45c7ce07f13174f9fe51a1c923d00d8a.jpg";